import {
  SEARCH_USERS_KYC_REQUEST,
  SEARCH_USERS_KYC_SUCCESS,
  SEARCH_USERS_KYC_FAIL,
  GET_PENDING_KYC_REQUEST,
  GET_PENDING_KYC_SUCCESS,
  GET_PENDING_KYC_FAIL,
  GET_KYC_DETAILS_REQUEST,
  GET_KYC_DETAILS_SUCCESS,
  GET_KYC_DETAILS_FAIL,
  GET_KYC_DETAILS_RESET,
  UPLOAD_KYC_DOCUMENT_REQUEST,
  UPLOAD_KYC_DOCUMENT_SUCCESS,
  UPLOAD_KYC_DOCUMENT_FAIL,
  SUBMIT_MANUAL_KYC_REQUEST,
  SUBMIT_MANUAL_KYC_SUCCESS,
  SUBMIT_MANUAL_KYC_FAIL,
  APPROVE_MANUAL_KYC_REQUEST,
  APPROVE_MANUAL_KYC_SUCCESS,
  APPROVE_MANUAL_KYC_FAIL,
  REJECT_MANUAL_KYC_REQUEST,
  REJECT_MANUAL_KYC_SUCCESS,
  REJECT_MANUAL_KYC_FAIL,
} from '../constants/manualKYCConstants'

// Search users reducer
export const searchUsersKYCReducer = (state = { users: [] }, action) => {
  switch (action.type) {
    case SEARCH_USERS_KYC_REQUEST:
      return { loading: true, users: [] }
    case SEARCH_USERS_KYC_SUCCESS:
      return { loading: false, users: action.payload }
    case SEARCH_USERS_KYC_FAIL:
      return { loading: false, error: action.payload, users: [] }
    default:
      return state
  }
}

// Pending KYC reducer
export const pendingKYCReducer = (state = { requests: [], pagination: {} }, action) => {
  switch (action.type) {
    case GET_PENDING_KYC_REQUEST:
      return { loading: true, requests: [], pagination: {} }
    case GET_PENDING_KYC_SUCCESS:
      return { 
        loading: false, 
        requests: action.payload.data, 
        pagination: action.payload.pagination 
      }
    case GET_PENDING_KYC_FAIL:
      return { loading: false, error: action.payload, requests: [], pagination: {} }
    default:
      return state
  }
}

// KYC details reducer
export const kycDetailsReducer = (state = { details: null }, action) => {
  switch (action.type) {
    case GET_KYC_DETAILS_REQUEST:
      return { loading: true, details: null }
    case GET_KYC_DETAILS_SUCCESS:
      return { loading: false, details: action.payload }
    case GET_KYC_DETAILS_FAIL:
      return { loading: false, error: action.payload, details: null }
    case GET_KYC_DETAILS_RESET:
      return { details: null }
    default:
      return state
  }
}

// Upload document reducer
export const uploadKYCDocumentReducer = (state = {}, action) => {
  switch (action.type) {
    case UPLOAD_KYC_DOCUMENT_REQUEST:
      return { loading: true }
    case UPLOAD_KYC_DOCUMENT_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case UPLOAD_KYC_DOCUMENT_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

// Submit KYC reducer
export const submitKYCReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBMIT_MANUAL_KYC_REQUEST:
      return { loading: true }
    case SUBMIT_MANUAL_KYC_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case SUBMIT_MANUAL_KYC_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

// Approve KYC reducer
export const approveKYCReducer = (state = {}, action) => {
  switch (action.type) {
    case APPROVE_MANUAL_KYC_REQUEST:
      return { loading: true }
    case APPROVE_MANUAL_KYC_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case APPROVE_MANUAL_KYC_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

// Reject KYC reducer
export const rejectKYCReducer = (state = {}, action) => {
  switch (action.type) {
    case REJECT_MANUAL_KYC_REQUEST:
      return { loading: true }
    case REJECT_MANUAL_KYC_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case REJECT_MANUAL_KYC_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}
